import { API_URL } from 'config';
import { useNotificationStore } from 'stores/notifications';
import Axios from 'axios';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

function authRequestInterceptor(config) {
  const temp_token = Cookies.get('temp_token');
  const token = Cookies.get('token');
  if (temp_token) {
    config.headers.authorization = `Bearer ${temp_token}`;
  } else if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  config.headers.Accept = 'application/json';

  return config;
}

authRequestInterceptor.propTypes = {
  config: PropTypes.any,
};

export const axios = Axios.create({
  baseURL: API_URL,
});
// timeout in milliseconds
axios.defaults.timeout = 50000;
axios.defaults.timeoutErrorMessage =
  '😟 Server is taking longer than usual to respond.';

// add multipart/form-data support
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const errorMsg =
      error.response?.data?.message || error.response?.data?.error;
    useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Something went wrong',
      message: errorMsg ? errorMsg : 'Please check server connection',
    });

    return Promise.reject(error);
  }
);
